import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    buttonContinue: {
        color: themes.palette.primary.main,
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontFamily: 'Poppins',
        width: '100%',
        fontWeight: 500,
        fontSize: '14px',
        textAlign: 'center',
    },
}));
